import * as React from 'react'
import { Col } from 'react-bootstrap'
import { Link } from 'gatsby'
import { collectionsCard, heading, text } from './collections-card.module.scss'

export default function CollectionsCard({ category }) {
  const background = category.image.gatsbyImageData.images.fallback
    ? category.image.gatsbyImageData.images.fallback.src
    : 'https://via.placeholder.com/640'
  return (
    <Col xs={6} lg={3} className='px-1'>
      <Link to={`/collections/${category.url}`}>
        <div
          className={collectionsCard}
          style={{
            background: `url('${background}')`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <p className={text}>{category.description.description}</p>
        </div>
        <h3 className={heading}>{category.category}</h3>
      </Link>
    </Col>
  )
}
